import { Button } from '@design/components/button/Button';
import { Input, InputProps } from '@design/components/input/Input';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './PasswordInput.module.scss';

export const PasswordInput = ({ id, name, label, ...rest }: InputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const { t } = useTranslation('auth');

  const togglePassword = () => {
    setIsPasswordVisible(isPasswordVisible => !isPasswordVisible);
  };

  return (
    <Input
      className={styles.styledInput}
      id={id}
      label={label || t('auth:form.passwordLabel')}
      name={name}
      type={isPasswordVisible ? 'text' : 'password'}
      rightIcon={
        <span className={styles.buttonWrapper}>
          <Button
            iconName={isPasswordVisible ? 'ShowPassword' : 'HidePassword'}
            size="small"
            variant="empty"
            type="button"
            onClick={togglePassword}
          />
        </span>
      }
      {...rest}
    />
  );
};
